<template>
  <div
    class="certificate-Pedestal-wrapper"
    :class="{ 'exercised-bg': fileDetail.nvsFileStatus === 'CONFIRM/Exercise' }"
  >
    <div class="shape1" />
    <div class="shape2" />
    <div class="shape3">
      <img
        :src="shapeRightBottom"
        alt="Fly Icon"
      >
    </div>
    <div class="shape4" />
    <div class="shape5" />
    <div class="shape6">
      <img
        :src="shapeLeftBottom"
        alt="Fly Icon"
      >
    </div>
    <div class="certificate-container">
      <div class="cf-logo">
        <img
          :src="lgIcon"
          alt="Fly Icon"
        >
      </div>
      <div class="large-tittle">
        Notice of full payment 全额付款通知书
      </div>
      <div class="top-shape">
        <img
          :src="shapeIcon"
          alt="Fly Icon"
        >
      </div>
      <div class="notice-content">
        <template v-if="fileDetail.purchasers && fileDetail.purchasers.length">
          <template v-if="fileDetail.purchasers.length > 6">
            <div class="notice-block half-col">
              <template v-for="item in fileDetail.purchasers.slice(0, 6)">
                <!-- eslint-disable -->
                <h3>{{ item.name }}</h3>
                <h4><span>Purchaser</span><span>{{ item.nric }}</span></h4>
                <!-- eslint-enable -->
              </template>
            </div>
            <div class="notice-block half-col">
              <template v-for="item in fileDetail.purchasers.slice(6, 12)">
                <!-- eslint-disable -->
                <h3>{{ item.name }}</h3>
                <h4><span>Purchaser</span><span>{{ item.nric }}</span></h4>
                <!-- eslint-enable -->
              </template>
            </div>
          </template>
          <template v-else>
            <div class="notice-block">
              <template v-for="item in fileDetail.purchasers">
                <!-- eslint-disable -->
                <h3>{{ item.name }}</h3>
                <h4><span>Purchaser</span><span>{{ item.nric }}</span></h4>
                <!-- eslint-enable -->
              </template>
            </div>
          </template>
        </template>
      </div>
      <div class="purcheser-info purchase-align-block">
        <div class="purchese-block">
          <p>File no.</p>
          <h3>{{ fileDetail.fileNo }}</h3>
        </div>
        <div class="purchese-block">
          <p>Product</p>
          <h3>Funeral Service Package</h3>
        </div>
        <div class="purchese-block">
          <p>Package</p>
          <h3>{{ packageName }}</h3>
        </div>
      </div>
      <div class="crf-center-text-pr">
        <p>We are delighted to inform you that the purchase price of your Nirvana product is now fully paid. We hereby confirm that you are entitled to all benefits, rights and interest as prescribed by us for the enjoyment of the aforesaid Nirvana product free from all encumbrances subject only to such restrictions and conditions as we may from time to time impose and the terms and conditions outlined in the Purchase Order.</p>
        <p>If you require any further clarification, please feel free to call us at +65 6397 2272. Alternatively, you can log in to the Nirvana SG app to view the information of the aforesaid Nirvana product.</p>
      </div>
      <div class="certificate-botom-content">
        <div class="maintenance-fees-wrapper custom-fsp-wrapper">
          <div class="maintenance-fees-right">
            <!-- <h2>富貴山莊</h2> -->
            <img :src="bottomChineseText">
            <h3><strong>NIRVANA MEMORIAL GARDEN PTE. LTD</strong> (Co. Reg. No. 200720733M)</h3>
            <p>950 Old Choa Chu Kang Road, Singapore 699816.</p>
            <p>Tel: (65) 63972272<span>Fax: (65) 67953070</span></p>
          </div>
        </div>
        <div class="gen-date">
          Generated on {{ today }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {} from 'bootstrap-vue'
import moment from 'moment'

export default {
  components: {},
  data() {
    return {
      fileDetail: JSON.parse(localStorage.getItem('fileDetail')),
      packageName: localStorage.getItem('packageName'),
      today: moment().format('DD MMMM YYYY'),
      // eslint-disable-next-line global-require
      shapeIcon: require('@/assets/images/certificate/shape-1.svg'),
      // eslint-disable-next-line global-require
      bottomChineseText: require('@/assets/images/certificate/certificate_bottom_chinese_text.svg'),
      // eslint-disable-next-line global-require
      lgIcon: require('@/assets/images/certificate/cf.svg'),
      // eslint-disable-next-line global-require
      shapeLeftBottom: require('@/assets/images/certificate/left-bottom-shape.svg'),
      // eslint-disable-next-line global-require
      shapeRightBottom: require('@/assets/images/certificate/right-top-shape.svg'),
    }
  },
}
</script>

<style>
    body div#app.semi-dark-layout {
        background: rgba(255, 248, 234, 0.70) !important;
        background-repeat: no-repeat !important;
        background-position: center bottom !important;
        background-size: 100% auto !important;
    }
    body {
        background: rgba(255, 248, 234, 0.70) !important;
    }
</style>
